<script>
export default {
  props: {
    show: Boolean,
    title: {
      type: String,
      default: "Confirm",
    },
    message: {
      type: String,
      default: "Are you sure?",
    },
    confirmText: {
      type: String,
      default: "Confirm",
    },
    confirmColor: {
      type: String,
      default: "primary",
    },
    cancelText: {
      type: String,
      default: "Cancel",
    },
  },
  emits: ["close", "confirm", "cancel"],
  methods: {
    confirm() {
      this.$emit("confirm");
      this.close();
    },
    cancel() {
      this.$emit("cancel");
      this.close();
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<template>
  <div v-if="show">
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-backdrop fade show" @click="close()"></div>
      <div class="modal-dialog">
        <div class="modal-content bg-dark text-white">
          <div class="modal-header border-0">
            <h4 class="modal-title">{{ title }}</h4>
            <button type="button" class="close text-white" @click="close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>{{ message }}</p>
          </div>
          <div class="modal-footer border-0">
            <button type="button" class="btn btn-warning" @click="cancel()">
              {{ cancelText }}
            </button>
            <button
              type="button"
              :class="['btn', `btn-${confirmColor}`]"
              @click="confirm"
            >
              {{ confirmText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "@/styles/modal.css";
</style>
